import React, { useState } from "react";

interface Tab {
  value: string;
  label: string;
}

interface ChunkyTabsProps {
  activeTab: string;
  tabs?: (Tab | null | undefined)[];
  short_tabs?: string[];
  setActiveTab: (tabId: string) => void;
}

export const ChunkyTabs: React.FC<ChunkyTabsProps> = ({
  activeTab,
  tabs,
  short_tabs,
  setActiveTab,
}) => {
  const [localTabs, setLocalTabs] = useState<Tab[]>(
    (short_tabs?.length ?? 0) > 0 && short_tabs
      ? short_tabs.map((value) => ({ value, label: value }) as Tab)
      : tabs?.filter((tab): tab is Tab => Boolean(tab)) || [],
  );
  return (
    <div className="w-full ">
      <div className="flex flex-row min-h-fit overflow-x-auto scrollbar-hide">
        {localTabs
          .filter((tab): tab is Tab => Boolean(tab))
          .map((tab, index) => (
            <div key={index} className="flex min-h-fit flex-row ">
              <button
                id={tab.value}
                className={` py-2 mb-2 text-sm font-medium  whitespace-nowrap transition-colors duration-200
                  ${
                    (index === 0 ? "rounded-l-lg" : "") +
                    (index === localTabs.length - 1 ? "rounded-r-lg" : "")
                  }
                  
                  ${
                    activeTab === tab.value
                      ? " text-neutral-900 bg-white shadow-md px-4 border border-neutral-200"
                      : "border-neutral-100 text-neutral-400  hover:border-neutral-300 bg-neutral-200 shadow-inner px-4"
                  }`}
                onClick={() => setActiveTab(tab.value)}
              >
                {tab.label}
              </button>
            </div>
          ))}
      </div>
    </div>
  );
};
